import { getReferrerForTracking } from '@web-platform/shared-banana-redux/src/helpers/getReferrerForTracking';
import { getUserDevice } from '@web-platform/shared-universal-redux/src/state';
import { getPageGroupName } from '@web-platform/shared-universal-redux/src/state/appInitial/pageGroup/reducers';
import { getStore } from '@web-platform/shared-universal-redux/src/store';
import * as minievent from '@web-platform/shared-universal-tracking/src/miniEvents';
import { isAcornType } from '@web-platform/shared-universal-utils-frontend/src/helpers/isAcornRequest';
import { GLOBAL } from 'saddlebag-browser';

import type {
  AcornState,
  BananaState,
} from '@web-platform/shared-universal-types/src/redux/state/state-shared-types';
import type { Metric } from 'web-vitals';

export const buildDiagonalScreenSizeInt = (windowWidth: number, windowHeight: number) => {
  const decimalPrecision = 1;
  if (!windowWidth && !windowHeight) {
    return undefined;
  }
  const sumOfSquares = windowWidth ** 2 + windowHeight ** 2;
  const diag = Math.round((Math.sqrt(sumOfSquares) / 72) * 10 ** decimalPrecision);

  return {
    amount: diag,
    precision: decimalPrecision,
  };
};

export const trackCoreWebVitalsPerformance = (metric: Metric) => {
  const { name, value } = metric;

  // @ts-expect-error web-vitals types name as `"CLS" | "FCP" | "FID" | "INP" | "LCP" | "TTFB"`. However, this is not accurate. In production we can see `UNSET_ENTRY` despite our explicit usage of `onLCP`, `onCLS`, and `onINP`.
  if (name === 'UNSET_ENTRY') return;

  const state = getStore().getState();

  if (isAcornType<AcornState, BananaState>(state)) {
    return;
  }

  const {
    browserName,
    browserVersion,
    isBrowser,
    isMobilePhone,
    isRobot,
    isTablet,
    osName,
    osVersion,
    vendor,
  } = getUserDevice(state);

  const { reconciledReferrer } = getReferrerForTracking(state);

  const pageGroup = getPageGroupName(state.appInitial.pageGroup);

  let clientDetails;

  if (name && value != null) {
    const $window = GLOBAL.getWindow();

    const { innerHeight: windowHeight, innerWidth: windowWidth, screen } = $window;

    const { height: screenHeight, pixelDepth: screenPixelDepth, width: screenWidth } = screen;

    clientDetails = {
      ipAddress: 'use header.client_ip',
      userAgent: 'use header.user_agent',
      osName,
      osVersion,
      isBrowser,
      isMobilephone: isMobilePhone,
      isTablet,
      browserName,
      browserVersion,
      vendorName: vendor,
      isRobot,
      usableDisplayHeight: windowHeight,
      usableDisplayWidth: windowWidth,
      displayHeight: screenHeight,
      displayWidth: screenWidth,
      displayPpi: screenPixelDepth,
      diagonalScreenSizeInt: buildDiagonalScreenSizeInt(windowWidth, windowHeight),
      referrerUrl: reconciledReferrer,
    };
  }

  const eventMessage = {
    entryType: name,
    value,
    pageType: pageGroup,
    clientDetails: {
      ...clientDetails,
    },
  };

  minievent.track('Web_Performance', 'sandbox_shiba.WebPerformance', eventMessage);
};
